module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="paylateBnr__title">\n    ';
 if (appConfig.isPaylateShare) { 
__p+='\n        Покупайте сейчас — платите через 120 дней!\n\n        <br />\n        Только до 21 декабря - 120 дней без переплат!\n    ';
 } else { 
__p+='\n        Покупайте сейчас — платите&nbsp;потом!\n    ';
 } 
__p+='\n</div>\n';
}
return __p;
};
